import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import noop from 'utils/noop';
import { FormField } from 'ui/formField';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/modal';
import { PrimaryButton } from 'ui/button';
import { BasicSelect } from 'ui/selects';
import { useTrackingDomain } from '../hooks';
import { setTrackingModalDropdownOptions } from './utils';
import { editSendingDomainRequest } from '../actions';
import { getIsLoading, getTrackingDomains } from '../selectors';
// import { SendingDomain } from '../types';

// type ModalProps = {
//   sendingDomain: SendingDomain,
//   onClose: () => {},
// };

export const SetTrackingDomainModal = ({ sendingDomain, onClose = noop }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(getIsLoading);
  const trackingDomains = useSelector(getTrackingDomains);

  // a custom useState function that
  // finds the currently displayed tracking domain
  // uses the first tracking domain,
  // if the sending domain does not have a tracking domain alreaduy assigned to it
  const [trackingDomain, setTrackingDomain] = useTrackingDomain(sendingDomain, trackingDomains);

  const dropdownOptions = useMemo(
    () => setTrackingModalDropdownOptions(trackingDomains),
    [trackingDomains],
  );
  const handleDropdownChange = useCallback(
    ([value]) => {
      // the dropdown uses the espAccounts ids as values
      const account = trackingDomains.find(({ domain }) => domain === value);
      setTrackingDomain(account);
    },
    [trackingDomains, setTrackingDomain],
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      editSendingDomainRequest(
        { ...sendingDomain, trackingDomain: trackingDomain.domain },
        "Updated the sending domain's tracking domain.",
      ),
    );
    onClose();
  };

  return (
    <Modal isModalOpen data-test="mailDomains-create-sending-domain-modal" onClose={onClose}>
      <ModalHeader>Set tracking domain</ModalHeader>
      <ModalBody>
        <form id="setTrackingDomain" onSubmit={handleSubmit}>
          <FormField
            key="trackingDomains"
            inputId="trackingDomainSelector"
            labelText="Select the tracking domain"
          >
            <BasicSelect
              isFullWidth
              options={dropdownOptions}
              defaultValues={[trackingDomain.domain]}
              onSelect={handleDropdownChange}
            />
          </FormField>
        </form>
      </ModalBody>
      <ModalFooter hasCancel onClose={onClose}>
        <PrimaryButton
          isDisabled={isLoading}
          key="submit"
          type="submit"
          form="setTrackingDomain"
          data-test="mailDomains-set-tracking-domain-modal-confirm-button"
        >
          Confirm
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
